var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-loader"},_vm._l((_vm.progressLines),function(line,index){return _c('div',{key:index,staticClass:"progress-line",class:{
      'is-filled': _vm.loadProgress >= line,
    }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }